export enum MigrationStatusEnum {
  NotInitiated = 'NotInitiated',
  Initiated = 'Initiated',
  Cancelled = 'Cancelled',
  Completed = 'Completed'
}
